import { FILTER_TYPES } from "taltech-styleguide";

export const colTitle = {
  dataField: "title",
  sort: true,
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-name"}>{col}</div>;
  },
  text: "Title",
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Title",
    type: FILTER_TYPES.TEXT,
  },
};
